import axios from './axios';
import SETTINGS from '../settings'
export default {
    sendEmail(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/sendemail`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    }
}